import { ApolloLink, SingleExecutionResult, fromPromise } from "@apollo/client";
import { hasCrypto } from "core/model/crypto";
import decryptPatcher from "./decryptPatcher";
import { getEncryptionDefinition } from "./queryKeys";
import { ContextType } from "./shared";

async function encryptionPromise(
  operationName: string,
  input: Record<string, any>,
  context: ContextType,
): Promise<SingleExecutionResult<Record<string, any>>> {
  const { encryptionContext } = context;
  const definition = getEncryptionDefinition(operationName, "encrypt");
  if (
    input != null &&
    definition &&
    hasCrypto() &&
    encryptionContext?.decrypt === true
  ) {
    const encryptedInput = await decryptPatcher({
      data: input,
      encryptionContext,
      encryptionDefinition: definition,
      mode: "encrypt",
    });
    return encryptedInput;
  }

  return input;
}

const encryptionLink = new ApolloLink((operation, forward) => {
  const input = operation.variables.input;
  const operationName = operation.operationName;
  const context = operation.getContext() as ContextType;

  return fromPromise(encryptionPromise(operationName, input, context)).flatMap(
    (encryptedInput: Record<string, any>) => {
      operation.variables.input = encryptedInput;
      return forward(operation);
    },
  );
});

export default encryptionLink;
